// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".note__B43pnbQc_ {\n  line-height: 1.6;\n  list-style: none;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Note/Note.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".note {\n  line-height: 1.6;\n  list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
export var note = "note__B43pnbQc_";
export default ___CSS_LOADER_EXPORT___;
